import { defineComponent as _defineComponent } from 'vue'
import SectionCustomerStories from '@components/Sections/SectionCustomerStories.vue';

import type { CustomerStory } from '@components/Sections/SectionCustomerStories.vue';

const CUSTOMER_STORIES: CustomerStory[] = [
  {
    id: '0',
    author: 'Dr. Joe Burgett, Clemson University',
    body: [
      'The Zephyr drone simulator is an outstanding tool and a cornerstone of my UAS courses at Clemson University.  Being able to train students on the fundamentals of drone operations without the risk of damaging an aircraft has been a game changer for us.  Because much of the flight training can be done without one-on-one instruction, I’m able to enroll more students in my classes.',
      'Additionally, I can not offer an online section to a traditionally in-person class.  The simulator is incredibly realistic which is no doubt why APSA has approved it for the BPERP exam. Our industry advisory board was very happy that we were able to use Zephyr as a mean to credential our students with the APSA flight proficiency certification.',
    ].join('\n\n'),
    image: '',
  },
  {
    id: '1',
    author: 'Cloud County Community College',
    body: [
      'Zephyr has given us the opportunity to introduce both high school and college students to the necessary flight operation skills to master drone flight. Each of the students has their own transmitter and can log onto their own computer at any time to sharpen their skills...',
      'The benefit of the LMS for grading student flight performance is an invaluable time saver for the instructor. Students that have never flown a remotely controlled aircraft have expressed how much the simulator helped their confidence before attempting to fly a real UAV.',
    ].join('\n\n'),
    image: '',
  },
  {
    id: '2',
    author: 'Brian Pitre, co-founder and managing member of SkyOp',
    body: 'We’ve beta tested the product and watched it come alive. Its enhanced graphics, dynamic training scenarios, active flight physics and Learning Management System are unparalleled in the industry today.',
    image: '',
  },
  {
    id: '3',
    author:
      'Skip Fredricks, Executive Producer/Chief Pilot Cinematographer at Hollywood Drones',
    body: 'As I developed the curriculum for a new college-level cinematography program, I began to realize that students needed a simulator that could give them a safe, economical platform on which to build a base of flight experience. Expanding on the flight skills already incorporated into the Zephyr Drone Simulator allows filmmakers to transfer the core photographic techniques like composition, panning, and reveals to the three-dimensional space available with a drone.',
    image: '',
  },
];

const __default__ = { name: 'MainSectionStories' };

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {


return { __sfc: true,CUSTOMER_STORIES, SectionCustomerStories }
}

})